// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3mqnT","balanceDisclaimer":"posDashboard_balanceDisclaimer__wk0B9"};